import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchRestaurantLists = createAsyncThunk(
  "restaurants/fetchLists",
  async () => {
    const response = await axios.get(`${BASE_URL}/api/lists/restaurant`);
    return response.data;
  }
);

export const fetchRestaurantList = createAsyncThunk(
  "restaurants/fetchList",
  async (sid) => {
    const response = await axios.get(`${BASE_URL}/api/lists/restaurant/${sid}`);
    return response.data;
  }
);

export const createRestaurantList = createAsyncThunk(
  "restaurants/createRestaurantList",
  async (newRestaurantList) => {
    const response = await axios.post(
      `${BASE_URL}/api/lists/restaurant`,
      newRestaurantList
    );
    return response.data;
  }
);

const restaurantListsSlice = createSlice({
  name: "restaurantLists",
  initialState: {
    restaurantLists: [],
    restaurantList: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearRestaurantList: (state) => {
      state.restaurantList = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch restaurant lists
      .addCase(fetchRestaurantLists.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRestaurantLists.fulfilled, (state, action) => {
        state.restaurantLists = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRestaurantLists.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // fetch restaurant list
      .addCase(fetchRestaurantList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRestaurantList.fulfilled, (state, action) => {
        state.restaurantList = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRestaurantList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // create restaurant list
      .addCase(createRestaurantList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createRestaurantList.fulfilled, (state, action) => {
        state.restaurantList = action.payload; // created restaurant list
        state.isLoading = false;
      })
      .addCase(createRestaurantList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearRestaurantList } = restaurantListsSlice.actions;

export default restaurantListsSlice.reducer;
